/** Manages a set of Preact subviews within a non-Preact parent view */
import * as preact from "preact";

export default class PreactSubviewManager {
  /** A map of subview name to the root DOM element which that subview controls */
  subviewElements: Record<string, HTMLElement> = {};

  /**
   * Adds a preact view to the given domElement, removing any existing view with the same name
   * first if necessary.
   */
  add(name: string, preactElement: preact.VNode<any>, domElement: HTMLElement) {
    if (this.subviewElements[name]) {
      this.remove(name);
    }
    preact.render(preactElement, domElement);
    this.subviewElements[name] = domElement;
  }

  /** Removes the named preact view from the DOM */
  remove(name: string) {
    const domElement = this.subviewElements[name];
    if (domElement) {
      preact.render(null, domElement);
      delete this.subviewElements[name];
    }
  }

  /**
   * Removes all preact subviews from the DOM. The parent view should always call this before
   * removing itself to ensure that all subviews are cleaned up properly.
   */
  removeAll() {
    for (const name in this.subviewElements) {
      this.remove(name);
    }
  }
}
